import API from 'utils/api';
import { formatReceived } from 'utils/formatValues';
import { onSuccess, onError } from 'utils/handlers';

export const baseURI = '/cuentaunicasir/padrones-considerados/';

/**
 * GET Padrones Considerados
 * @returns {Promise<Array<object>>}
 */
export const getPadronesConsiderados = async (params = null) => {
  try {
    const response = await API.get(baseURI, { params });
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Padron Considerado
 * @param {number} id
 * @returns {Promise<object>}
 */
export const getPadronConsiderado = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}`);
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return null;
  }
};

/**
 * POST Padrones Considerados
  * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postPadronConsiderado = async (values) => {
  try {
    const promises = values.map((value) => API.post(baseURI, value));
    await Promise.all(promises);
    onSuccess(null, 'Agregado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Padrones Considerados
 * @param {number} id
 * @param {Array} values
 * @returns {Promise<object|boolean>}
 */
export const patchPadronConsiderado = async (id, values = []) => {
  try {
    const promises = values.map((value) => API.patch(`${baseURI}${id}`, value));
    await Promise.all(promises);
    onSuccess(null, 'Editado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Padrones Considerados
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const deletePadronConsiderado = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
